import React from "react";
import VisionMission from "../pages/VisionMission";
import TestimonialSectionabout from "../pages/Testimonialsabout";
import ShivaiFAQ from "../pages/shivaiFaqs";
import WhyChooseShivaiTravels from "../pages/WhyChooseShivaiTravels ";

const AboutSection = () => {
  return (
    <>

      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white">
                About Shivai Travels
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div
        className="section-full site-bg-white py-2 twm-abus-section-wrap wow fadeInDown"
        data-wow-offset="100"
        data-wow-delay="0.2s"
      >
        <div className="container">
          <div className="row twm-abus-section">

            {/* LEFT SIDE */}
            <div className="col-lg-7 col-md-12">
              <div className="twm-abus-left">

                <div className="twm-media">
                  <img src="images/abus-pic.jpg" alt="Shivai Travels About" />

                 

                  <div className="twm-abus-year-section">
                    <div className="tem-abus-year-content">
                      <span>Since</span>
                      <h2 className="year-title">2016</h2>
                    </div>
                  </div>
                </div>

                <div className="twm-media2">
                  <img src="/images/About.png" alt="Shivai Travels Fleet" />
                </div>

              </div>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-5 col-md-12">

              {/* TITLE START */}
              <div className="section-head left aside-section">
                <div className="twm-sm-title left">About Shivai Travels</div>

                <h2 className="twm-large-title site-text-dark">
                  Affordable & Reliable Cab Services in Pune
                </h2>

                <div className="section-head-detail">
                  Shivai Travels is a trusted car rental and taxi service provider
                  offering safe, comfortable, and affordable travel solutions in Pune
                  and across Maharashtra. We specialize in outstation trips, airport
                  transfers, local travel, and group tours with a wide range of
                  vehicles including Sedan, SUV, Innova Crysta, Ertiga, Urbania,
                  and Tempo Travellers. Our focus is on customer satisfaction,
                  punctual service, and professional drivers.
                </div>
              </div>
              {/* TITLE END */}

          <div className="twm-inline-list2">
  <ul>

    <li>
      <i className="fa-solid fa-car"></i>
      Wide Range of Vehicles Available
    </li>

    <li>
      <i className="fa-solid fa-headset"></i>
      24/7 Customer & Roadside Assistance
    </li>

    <li>
      <i className="fa-solid fa-indian-rupee-sign"></i>
      Affordable & Transparent Pricing
    </li>

    <li>
      <i className="fa-solid fa-user-tie"></i>
      Experienced & Professional Drivers
    </li>

  </ul>
</div>

             

            </div>

          </div>
        </div>
      </div>

      <VisionMission />

      <TestimonialSectionabout/>
      <ShivaiFAQ/>
      <WhyChooseShivaiTravels/>
    </>
  );
};

export default AboutSection;